module.exports = __webpack_public_path__ + "img/receipt.8559ba37.svg";